import { supabaseClient } from 'supabase'

export const deleteCreative = async (id: string) => {
  const { error } = await supabaseClient
    .from('creatives')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }

  return { success: true }
}